
// SVG Icon: gallery
export default { id: "terriajs-gallery" };
export const id = "terriajs-gallery";
export const name = "gallery";
